import React, { useState } from "react";

import { AiOutlineUserAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import { api_url } from "../../data";
import axios from "axios";
import { useEffect } from "react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { RotatingLines } from "react-loader-spinner";
import { useGlobalContext } from "../../context/stateContext";
import { useAuth } from "../../context/Auth";
import Header from "../../components/Header";

const Churches = () => {
  const { requestWithAuth } = useAuth();
  const { user } = useGlobalContext();
  const [registeredChurches, setRegisteredChurches] = useState([]);

  const [loadingChurches, setLoadingChurches] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [pageSize, setPageSize] = useState(20);

  const filterMembersList = (search_query) => {
    setSearch(search_query);
    setCurrentPage(1);
  };

  // GET REGISTERED MEMBERS
  const getChurches = async (page, searchQuery) => {
    try {
      setLoadingChurches(true);
      const data = await requestWithAuth(
        `/superadmin/churches?page=${page}&search=${searchQuery}`,
        "GET"
      );
      setRegisteredChurches(data?.results);
      setNextPage(data?.next);
      setPrevPage(data?.prev);
      setTotalPages(Math.ceil(data?.count / pageSize));
    } catch (error) {
      
      toast.error("Failed to get church list");
    } finally {
      setLoadingChurches(false);
    }
  };

  

  const handleNextPage = () => {
    if (nextPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (prevPage) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const totalNumbersToShow = 3; // Number of pages to show around the current page
    const totalPagesToShow = 5; // Total pages to show at start and end

    let startPage = Math.max(1, currentPage - totalNumbersToShow);
    let endPage = Math.min(totalPages, currentPage + totalNumbersToShow);

    // Always show the first page
    if (startPage > 1) {
      pageNumbers.push(1);
      if (startPage > 2) {
        pageNumbers.push("...");
      }
    }

    // Show the numbers around the current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    // Always show the last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push("...");
      }
      pageNumbers.push(totalPages);
    }

    return pageNumbers.map((number) => (
      <button
        key={number}
        onClick={() => number !== "..." && handlePageClick(number)}
        className={
          number === currentPage
            ? "border border-[#979797] bg-gradient-to-b from-white to-[#dcdcdc] py-[0.5rem] px-[1rem]"
            : "border border-[#979797] bg-gradient-to-b from-white to-[#dcdcdc] py-[0.5rem] px-[1rem]"
        }
      >
        {number}
      </button>
    ));
  };

  useEffect(() => {
    getChurches(currentPage, search);
  }, [currentPage, search]);
  return (
    <div>
      <Header title="Churches" />
      {user?.role === "Superadmin" && (
        <Link
          to="/super/churches/new"
          className="flex items-center gap-3 rounded px-4 py-2 bg-green-800 hover:bg-green-900 cursor-pointer text-white w-max"
        >
          <AiOutlineUserAdd /> Register Church
        </Link>
      )}

      <div className="mt-5 rounded border border-gray-100">
        <div className="px-4 py-2 flex flex-col lg:flex-row gap-5 lg:items-center justify-between">
          <h2>Registered Churches</h2>
          <input
            type="text"
            placeholder="Search by name..."
            onChange={(e)=>filterMembersList(e.target.value)}
            className="px-2 py-2 border border-slate-300 rounded"
          />
        </div>

        <div className="overflow-x-auto">
          <div className="inline-block min-w-full py-2">
            <div className="overflow-hidden">
              <table className="min-w-full text-left text-sm font-light text-surface">
                <thead className="w-screen font-medium">
                  <tr className="bg-slate-100 border-b border-t border-slate-200 text-black">
                    <th className="px-6 py-2 font-medium">Church ID</th>
                    <th className="px-6 py-2 font-medium">Church Name</th>
                    <th className="px-6 py-2 font-medium">Location</th>
                    <th className="px-6 py-2 font-medium">Status</th>
                    <th className="px-6 py-2 font-medium">Action</th>
                  </tr>
                </thead>
                {!loadingChurches && (
                  <tbody>
                    {registeredChurches?.map((church, index) => (
                      <tr key={index} className="border-b border-slate-200">
                        <td className="px-6 py-2">
                          {church?.church_id}
                        </td>
                        <td className="px-6 py-2">{church?.church_name}</td>
                        <td className="px-6 py-2">{church?.church_location}</td>
                        <td className="px-6">
                          <div className="flex items-center gap-1">
                            <div className={` h-2 w-2 rounded-full ${church.church_status == "Active" ? "bg-green-500" : "bg-red-500"} `}>
                            </div>
                            {church.church_status}
                          </div>
                        </td>
                        <td className="px-6 py-2">
                          <Link to={`/super/churches/${church?.id}/detail`} className="text-blue-800 underline">
                            View Details
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
              {
                loadingChurches && (
                  <div className="flex items-center justify-center py-5">
                    <RotatingLines 
                      strokeColor="black"
                      height="20"
                      width="20"
                    />
                  </div>
                )
              }
              {
                !loadingChurches && registeredChurches?.length == 0 && (
                  <p className="text-center py-5">No data found</p>
                )
              }
            </div>
          </div>
        </div>
        {registeredChurches?.length > 0 && (
          <div className="px-6 flex justify-between items-center my-5">
            <p>
              Page {currentPage} of {totalPages}
            </p>
            <div className="flex flex-col gap-2 items-start md:px-5 md:flex-row">
              <button
                onClick={() => handlePreviousPage()}
                className={`border border-primary px-4 py-2 ${
                  !prevPage ? "text-primary bg-white" : "text-white bg-primary"
                }`}
              >
                Previous
              </button>
              {renderPageNumbers()}
              <button
                onClick={() => handleNextPage}
                className={`border border-primary px-4 py-2 ${
                  !nextPage ? "text-primary bg-white" : "text-white bg-primary"
                }`}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>

      
    </div>
  );
};

export default Churches;
